const INPUT_REG = /输入\s*#?\d+/;
const INPUT_REG2 = /input\s*\d+/;
const OUTPUT_REG = /输出\s*#?\d+/;
const OUTPUT_REG2 = /output\s*\d+/;

function createContainerStartToken(Token: any) {
  const token = new Token('html_block', '', 1);
  token.content = '<div class="hetao-inout-container">';
  return token;
}
function createContainerEndToken(Token: any) {
  const token = new Token('html_block', '', -1);
  token.content = '</div>';
  return token;
}
function createItemStartToken(Token: any, isLeft = false) {
  const token = new Token('html_block', '', 1);
  token.content = `<div class="hetao-inout-item ${isLeft ? 'hetao-inout-left' : 'hetao-inout-right'}">`;
  return token;
}
function createItemEndToken(Token: any, isLeft = false) {
  const token = new Token('html_block', '', -1);
  token.content = '</div>';
  // 标记当前代码块是左边的代码块，需要增加运行按钮
  token.meta = { isLeft };
  return token;
}
function isTokenCode(token: any) {
  return (
    token &&
    token.block &&
    token.tag === 'code' &&
    token.type === 'fence' &&
    token.nesting === 0 &&
    token.level === 0
  );
}
function isTokenInputCode(token: any) {
  return (
    token &&
    token.block &&
    token.tag === 'code' &&
    token.type === 'fence' &&
    token.nesting === 0 &&
    token.level === 0 &&
    INPUT_REG2.test(token.info)
  );
}
function isTokenOutputCode(token: any) {
  return (
    token &&
    token.block &&
    token.tag === 'code' &&
    token.type === 'fence' &&
    token.nesting === 0 &&
    token.level === 0 &&
    OUTPUT_REG2.test(token.info)
  );
}
function isTokenHeadingOpen(token: any) {
  return (
    token &&
    token.block &&
    (token.tag === 'h2' || token.tag === 'h3') &&
    token.type === 'heading_open' &&
    token.nesting === 1 &&
    token.level === 0
  );
}
function isTokenHeadingClose(token: any) {
  return (
    token &&
    token.block &&
    (token.tag === 'h2' || token.tag === 'h3') &&
    token.type === 'heading_close' &&
    token.nesting === -1 &&
    token.level === 0
  );
}
function isTokenInputHeader(token: any) {
  return (
    token &&
    token.block &&
    token.tag === '' &&
    token.type === 'inline' &&
    token.nesting === 0 &&
    token.level === 1 &&
    INPUT_REG.test(token.content)
  );
}
function isTokenOutputHeader(token: any) {
  return (
    token &&
    token.block &&
    token.tag === '' &&
    token.type === 'inline' &&
    token.nesting === 0 &&
    token.level === 1 &&
    OUTPUT_REG.test(token.content)
  );
}

/**
 * 新OJ的输入输出规则
 * ## 输入 #1
 * ```
 * 1 2
 * ```
 * ## 输出 #1
 * ```
 * 3
 * ```
 */
function matchRule1(tokens: any[], i: number) {
  if (
    isTokenCode(tokens[i]) &&
    isTokenHeadingClose(tokens[i - 1]) &&
    isTokenInputHeader(tokens[i - 2]) &&
    isTokenHeadingOpen(tokens[i - 3]) &&
    isTokenHeadingOpen(tokens[i + 1]) &&
    isTokenOutputHeader(tokens[i + 2]) &&
    isTokenHeadingClose(tokens[i + 3]) &&
    isTokenCode(tokens[i + 4])
  ) {
    // 按照固定顺序匹配到了输入代码和输出代码
    return true;
  }
}

/**
 * 老OJ的输入输出规则
 * ```input1
 * 10
 * ```
 * ```output1
 * Good!
 * ```
 */
function matchRule2(tokens: any[], i: number) {
  if (isTokenInputCode(tokens[i]) && isTokenOutputCode(tokens[i + 1])) {
    // 按照固定顺序匹配到了输入代码和输出代码
    return true;
  }
}

interface GroupVO {
  type: number;
  start: number;
}
function insertWrapTokensByGroups(
  tokens: any[],
  groups: GroupVO[],
  Token: any,
) {
  let groupOffset = 0;
  const oTokens = tokens.slice();
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    const start = group.start;

    const containerOpen = createContainerStartToken(Token);
    const containerClose = createContainerEndToken(Token);

    const item1Open = createItemStartToken(Token, true);
    const item1Close = createItemEndToken(Token, true);

    const item2Open = createItemStartToken(Token, false);
    const item2Close = createItemEndToken(Token, false);

    let list = [] as any[];
    if (group.type === 1) {
      list = [
        containerOpen,
        item1Open,
        oTokens[start],
        oTokens[start + 1],
        oTokens[start + 2],
        oTokens[start + 3],
        item1Close,
        item2Open,
        oTokens[start + 4],
        oTokens[start + 5],
        oTokens[start + 6],
        oTokens[start + 7],
        item2Close,
        containerClose,
      ];
      tokens.splice(start + groupOffset, 8, ...list);
    } else if (group.type === 2) {
      list = [
        containerOpen,
        item1Open,
        oTokens[start],
        item1Close,
        item2Open,
        oTokens[start + 1],
        item2Close,
        containerClose,
      ];
      tokens.splice(start + groupOffset, 2, ...list);
    }

    groupOffset += 6;
  }
}

export function markdownItInputOutput(md: any) {
  md.core.ruler.push('merge_div_tokens', function (state: any) {
    const tokens = state.tokens;
    const len = tokens.length;

    const groups = [];

    for (let i = 0; i < len; i++) {
      if (matchRule1(tokens, i)) {
        groups.push({ type: 1, start: i - 3 });
      }
      if (matchRule2(tokens, i)) {
        groups.push({ type: 2, start: i });
      }
    }

    insertWrapTokensByGroups(tokens, groups, state.Token);
  });
}
